// Podtemat 4 - zadania otwarte egzaminu osmoklasisty z dzialu VIII (stereometria).

import * as SquarePyramidEdges from "./podtemat4_e8_otwarte_types/E8SquarePyramidEdgesOpenTask";
import * as CubePyramidVolumeRatio from "./podtemat4_e8_otwarte_types/E8CubePyramidVolumeRatioOpenTask";

export const registry = {
  E8SquarePyramidEdgesOpenTask: SquarePyramidEdges,
  E8CubePyramidVolumeRatioOpenTask: CubePyramidVolumeRatio,
};

export function generateTasks(options = {}) {
  if (options.variant === "original" && options.session === "2026_MAJ") {
    return [CubePyramidVolumeRatio.generateTask(options)];
  }

  return [
    SquarePyramidEdges.generateTask(options),
    CubePyramidVolumeRatio.generateTask(options),
  ];
}

function moduleFor(task) {
  const mod = registry[task.type];
  if (!mod) throw new Error(`Unknown E8 open task type in stereometria: ${task.type}`);
  return mod;
}

export function renderTask(task) {
  return moduleFor(task).renderTask(task);
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return moduleFor(task).renderInput(task, userAnswer, onChange, disabled);
}

export function checkAnswer(task, userAnswer) {
  return moduleFor(task).checkAnswer(task, userAnswer);
}

export function renderAnswer(task) {
  return moduleFor(task).renderAnswer(task);
}

export function renderExplanation(task) {
  return moduleFor(task).renderExplanation(task);
}

export function renderUserAnswer(userAnswer, task) {
  return moduleFor(task).renderUserAnswer(userAnswer, task);
}